export default __webpack_public_path__ + "static/media/05.e66687ca.png";